import { ChangeEvent } from "react";
import { useSelectTheme } from "../../store";

export interface CheckboxProps {
  value: boolean;
  name?: string;
  /** When set, associate visible label text with `<label htmlFor={id}>`. */
  id?: string;
  color?: string;
  disableCheck?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  from?: string; // for RTL
  ariaLabel?: string;
}

/* a styled checkbox */
export const Checkbox = (props: CheckboxProps) => {
  const { color } = useSelectTheme();

  const { value, name, disableCheck, onChange, disabled, ariaLabel, id } = props;
  const checkboxColor = disabled
    ? color.textIcon.disabled
    : props.color
      ? props.color
      : color.primary;
  const checkboxBorderColor = disabled ? color.border.disabled : color.grey_600;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (disableCheck) return e.preventDefault();
    if (onChange) onChange(e.target.checked);
  };

  return (
    <label
      data-testid="checkbox_label"
      css={{
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        height: "16px",
        minHeight: "16px",
        width: "16px",
        minWidth: "16px",
        background: `${value ? checkboxColor : color.white}`,
        border: `${value ? "" : `1px solid ${checkboxBorderColor}`}`,
        borderRadius: "3px",
        ":focus-within": {
          outline: `2px solid ${color.primary}`,
          outlineOffset: "2px",
        },
      }}
    >
      <input
        data-testid={`checkbox_input${props.from ? props.from : ""}`}
        id={id}
        type="checkbox"
        name={name}
        checked={value || false}
        onChange={handleChange}
        disabled={disabled}
        css={{
          position: "absolute",
          opacity: 0,
          width: "100%",
          height: "100%",
          margin: 0,
          cursor: "pointer",
        }}
      />
      <span
        css={{
          position: "absolute",
          top: "1.5px",
          left: "5px",
          height: "11px",
          width: "6px",
          border: `solid ${color.white}`,
          borderWidth: "0 2px 2px 0",
          transform: "rotate(45deg)",
          display: `${value ? "block" : "none"}`,
        }}
      />
      {ariaLabel ? (
        <span
          css={{
            border: 0,
            clip: "rect(0 0 0 0)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            width: "1px",
            whiteSpace: "nowrap",
          }}
        >
          {ariaLabel}
        </span>
      ) : null}
    </label>
  );
};
